export type ActivityStatus = {
    activityId: string;
    status: string;
    modifiedDate: string;
    activityName?: string;
    activityDate?: number;
};

export type AthleteStatusResponse = {
    activityId: string;
    athleteId: string;
    status: string;
    dataSource: string;
    modifiedDate: string;
};

export const MOCK_ATHLETES_LIST = [{ id: 'ath1' }, { id: 'ath2' }, { id: 'ath3' }, { id: 'ath4' }];

export function generateMockActivityStatus() {
    const status_options = ['status:baking', 'status:baked 3', 'error:mock error'];
    return status_options[Math.floor(Math.random() * 3)];
}

export function generateMockAthleteStatuses(activityId: string): AthleteStatusResponse[] {
    const status_options = ['Pending', 'Baking', 'Completed', 'Error']; // WIP, TBC
    const data_source_options = ['Live', 'Munged'];
    return MOCK_ATHLETES_LIST.map((athlete) => {
        return {
            activityId,
            athleteId: athlete.id,
            status: status_options[Math.floor(Math.random() * 4)],
            dataSource: data_source_options[Math.floor(Math.random() * 2)],
            modifiedDate: new Date().toISOString(),
        };
    });
}

// process.env.REACT_APP_ENVIRONMENT doesn't work on deployed instances so we have to get the env from the url
export function getBakerEnv() {
    const url = window.location.hostname;

    if (url.includes('alpha-') || url.includes('beta-') || url.includes('gengar-')) {
        return 'alpha'; // beta and gengar dont have baker API deployments
    } else if (url.includes('localhost')) {
        return 'dev';
    } else {
        return 'prod';
    }
}

export function getBaseUrl(region: string, env: string) {
    return `https://of-${env}-${region}-cloudbaker-api.openfield.catapultsports.com`;
}

export function getApiRegion(awsRegion: string) {
    const parts = awsRegion.split('-');
    return parts[0][0] + parts[1][0] + parts[2][0];
}

export function getMockActivityStatus(activityId: string) {
    return {
        activityId,
        status: generateMockActivityStatus(),
        modifiedDate: new Date().toISOString(), // the response from the API is an OpenAPI 'date-time' string (RFC3339)
    };
}

export function getMockAthletesStatus(activityId: string) {
    const athleteStatuses: AthleteStatusResponse[] = generateMockAthleteStatuses(activityId);
    return athleteStatuses;
}
